export default {
  nome: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/links/components/search/search-form.js